import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import { OdsPriorityGroups } from "../../../interfaces/ODSPriorityGroups";
import { ErrorResponse } from "react-router-dom";
const { REACT_APP_API_PATH } = process.env;

interface GetODSQuery {

}

interface GetODSResponse {
    ods: OdsPriorityGroups[] | null
    error: boolean
}

export const getODS = createAsyncThunk<GetODSResponse>(
    "transversal_approaches/ods",
    async () => {
        try {
            let url = `${REACT_APP_API_PATH}/ods`;

            const response = await axiosInstance.get(url);
            const data = response.data;

            return {
                ods: data.data,
                error: false
            };

        } catch (error) {
            return {
                ods: [],
                error: true
            };
        }
    }
);

export const getPriorityGroups = createAsyncThunk(
    "transversal_approaches/priority_groups",
    async () => {
        try {
            let url = `${REACT_APP_API_PATH}/grupos-prioritarios`;

            const response = await axiosInstance.get(url);
            const data = response.data;

            return {
                priority_groups: data.data.data,
                error: false
            };

        } catch (error) {
            return {
                priority_groups: [],
                error: true
            };
        }
    }
);